import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination inner"
}
const _hoisted_2 = {
  key: 2,
  class: "pages"
}
const _hoisted_3 = ["onClick"]

import { ref } from "vue";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    pageIndex: {},
    pageCount: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;

const footerPages = ref<any[]>([]);
const paginatorCount = ref(0);
const paginatorIndex = ref(0);

paginatorCount.value = Math.ceil(props.pageCount / 4);
paginatorIndex.value = Math.trunc((props.pageIndex - 1) / 4);
footerPages.value = [...Array(props.pageCount).keys()].slice(paginatorIndex.value * 4, (paginatorIndex.value + 1) * 4);

async function setSearch(index: number) {
    const url = new URL(window.location.href);
    url.searchParams.set("page", (index).toString());
    window.location.href = url.toString();
}

async function goToPage(index: number) {
    setSearch(index);
}

async function goToPrevPage() {
    if (props.pageIndex < 2) {
        return;
    }
    setSearch((props.pageIndex - 1));
}

async function goToNextPage() {
    if (props.pageIndex >= props.pageCount) {
        return;
    }
    setSearch((props.pageIndex + 1));
}

function goToPageSelector(type: string) {
    if (type === "plus") {
        goToPage(footerPages.value.slice(-1)[0] + 2);
    }

    if (type === "less") {
        goToPage(footerPages.value.slice(0)[0]);
    }
}

return (_ctx: any,_cache: any) => {
  return (__props.pageCount > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.pageIndex > 1)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPrevPage())),
              class: "button"
            }, _toDisplayString(_unref(localizer).get("App.Pagination.Prev")), 1))
          : _createCommentVNode("", true),
        (paginatorIndex.value >= 1)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPageSelector('less'))),
              class: "button dots"
            }, "..."))
          : _createCommentVNode("", true),
        (footerPages.value.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerPages.value, (page, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: 'page_' + index,
                  onClick: ($event: any) => (goToPage(page + 1)),
                  class: _normalizeClass([{ 'selected': __props.pageIndex - 1 === page }, 'button'])
                }, _toDisplayString(page + 1), 11, _hoisted_3))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (paginatorCount.value >= 1 && (paginatorIndex.value + 1) !== paginatorCount.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPageSelector('plus'))),
              class: "button dots"
            }, "..."))
          : _createCommentVNode("", true),
        (__props.pageIndex !== __props.pageCount)
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goToNextPage())),
              class: "button"
            }, _toDisplayString(_unref(localizer).get("App.Pagination.Next")), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})